import { render } from "./HeaderVpos.vue?vue&type=template&id=27a7d2a4&scoped=true"
import script from "./HeaderVpos.vue?vue&type=script&lang=js"
export * from "./HeaderVpos.vue?vue&type=script&lang=js"

import "./HeaderVpos.vue?vue&type=style&index=0&id=27a7d2a4&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-27a7d2a4"]])

export default __exports__